import React from 'react';
import classnames from 'classnames';
import { Typography, Icon, Popconfirm } from 'antd';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';

import generatePath from '~settings/routing';
import { DELETE_ARTICLE } from '../../gql';

export default function ArticleOverview({ articleData, sortNumber = 1, refetch, type }) {
  const history = useHistory();
  const articlePath = generatePath('editArticleDesign', {
    type,
    index: sortNumber,
    id: articleData.id,
  });

  const handleEditArticle = () => {
    history.push(articlePath);
  };

  const [deleteArticle] = useMutation(DELETE_ARTICLE, {
    onCompleted: data => {
      if (data?.deleteArticle?.success) {
        refetch();
      }
    },
  });

  const handleDelete = () => {
    deleteArticle({ variables: { input: { id: articleData.id } } });
  };

  return (
    <div className={classnames('article-overview-wrapper', articleData?.image && 'grid-wrapper')}>
      <div className="prefix">{sortNumber}</div>
      <div className="left-content">
        <div>
          <p className="title">{articleData?.title}</p>
          <Typography.Paragraph ellipsis={{ rows: 2 }} className="content">
            {articleData?.textarea ?? 'No Content'}
          </Typography.Paragraph>
        </div>
        <div className="edit-row">
          <If condition={articleData?.status === 'PUBLISHED'}>
            <div className="published">
              <Icon type="check" className="icon" />
              Published
            </div>
          </If>
          <If condition={articleData?.status === 'DRAFT'}>
            <div className="draft">
              <Icon type="clock-circle" className="icon" />
              Draft
            </div>
          </If>
          <div className="edit" onClick={handleEditArticle}>
            Edit
          </div>
          <Popconfirm
            title="Are you sure delete this article?"
            okText="Delete"
            okType="danger"
            onConfirm={handleDelete}
            overlayClassName="article-confirm-container"
          >
            <div className="delete">Delete</div>
          </Popconfirm>
        </div>
      </div>
      <If condition={articleData?.image}>
        <img width={136} height={136} src={articleData?.image} className="image" />
      </If>
    </div>
  );
}
